export default {"src":"/_next/static/media/generic.f62c163d.svg","height":42,"width":32,"blurWidth":0,"blurHeight":0};